import * as React from 'react';
import { useIntl } from 'react-intl';

import { Box, Text, VStack } from '@fhs-legacy/universal-components';
import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { LoyaltyPoints } from 'components/loyalty-points';
import Table from 'components/table';
import { selectors, useAppSelector } from 'state/global-state';
import { useFlag } from 'utils/launchdarkly';
import { routes } from 'utils/routing';

import { Container, Content, TableWrap } from './loyalty-history-widget.styled';

const LoyaltyHistoryWidget: React.FC<React.PropsWithChildren<unknown>> = () => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const hidePointsExpirationEnabled = useFlag('enable-hide-points-expiration');
  const loyaltyUserExpireDateFormattedText = useAppSelector(
    selectors.loyalty.createLoyaltyUserExpireDateFormattedTextSelector(intl)
  );

  const table = React.useMemo(
    () => ({
      head: [
        {
          points: (
            <VStack alignItems="center" justifyContent="center" space={3}>
              <Box display="flex" flexDirection="row">
                {formatMessage({ id: 'rewardsPointsAvailable' }, { points: <LoyaltyPoints /> })}
              </Box>
              {!hidePointsExpirationEnabled && (
                <>
                  <Box marginBottom={3}>
                    <Text>
                      {formatMessage(
                        { id: 'rewardsPointsWillExpireDate' },
                        { date: <Text bold>{loyaltyUserExpireDateFormattedText}</Text> }
                      )}
                    </Text>
                  </Box>
                  <ActionButton to={routes.menu} fullWidth>
                    Order Now
                  </ActionButton>
                </>
              )}
            </VStack>
          ),
        },
      ],
      body: [
        {
          points: (
            <ActionButton variant={ActionButtonVariants.OUTLINE} to={routes.rewardsHistory}>
              View history
            </ActionButton>
          ),
        },
      ],
    }),
    [formatMessage, hidePointsExpirationEnabled, loyaltyUserExpireDateFormattedText]
  );

  return (
    <Container testID="history-widget">
      <Content>
        <TableWrap>
          <Table table={table} />
        </TableWrap>
      </Content>
    </Container>
  );
};

export default LoyaltyHistoryWidget;
